import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    dashboard_container: {
        display: 'grid',
        rowGap: '8px'
    },
    tools_container:{
        display: 'flex',
        padding: '8px',
        marginBottom: '16px',
        backgroundColor: theme.palette.common.white,
        borderRadius: '6px',
        boxSizing: 'border-box',
    },
    box_container:{
        display: "flex",
        flexDirection: "column",
        backgroundColor: theme.palette.common.white,
        boxSizing: 'border-box',
        borderRadius: '6px'
    },
    btn_container: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 8,
        marginBottom: 10
    }
}));

export {useStyles}